module.exports = __webpack_public_path__ + "static/media/Astron_4_t.fc30a61e.jpg";